import {useState, CSSProperties} from 'react';

type ModalProps = {
  header?: string;
  children: any;
  buttonP?: string;
  buttonS?: string;
  actionP: () => void;
  actionS: () => void;
  addon?: string;
  valid?: any
};

export function Modal({header, children, buttonP, buttonS, actionP, actionS, addon, valid}: ModalProps){
  const [showAddon, setShowAddon] = useState(false);
  const styles = getStyles();

  return (<div style={styles.background}>
    <div style={styles.modal}>
      {/*<Pressable style={{position: "absolute", top: 0, right: 0}} onPress={actionC}>*/}
      {/*  <div style={{color: "red", paddingRight: 7, paddingTop: 5}}>X</div>*/}
      {/*</Pressable>*/}
      <h2 style={{textAlign: 'center'}}>{header}</h2>
      <div className={"flex-column main-modal"}>{children}</div>
      {buttonP && (<button
        onClick={actionP}
        className={"primarybutton"}
        disabled={!valid}
        style={{right: 20, bottom: 30, position: "absolute"}}
      >{buttonP}</button>)}
      {buttonS && (<button
        onClick={actionS}
        className={"secondarybutton"}
        style={{right: 170, bottom: 29, position: "absolute"}}
      >{buttonS}</button>)}
      {addon && (<button
        onClick={() => setShowAddon((a) => !a)}
        style={{
          marginTop: 10,
          marginRight: 'auto',
          marginLeft: 'auto',
          width: 30,
          height: 5,
          borderRadius: 5,
          display: 'block'
        }}
      />)}
      {addon && showAddon && (<div style={{textAlign: 'center'}}>
        {addon.split(" - ")[0]}
        <div style={{color: "gray", whiteSpace: "break-spaces"}}>{addon.split(" - ")[1]}</div>
      </div>)}
    </div>
  </div>);
}

type Styles = {
  modal: CSSProperties; background: CSSProperties;
};

function getStyles(): Styles{
  return {
    modal: {
      borderRadius: 10,
      backgroundColor: 'var(--darkgray)',
      padding: "50px 30px 75px 30px",
      position: "relative",
      marginLeft:"5%",
      marginRight:"5%",
      minWidth: 330,
      maxHeight: "95vh"
    },
    background: {
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(22,28,39,0.8)',
      zIndex: 2000,
      position: 'fixed',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
}